var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAr2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2566 9.57983C12.5536 9.57983 11.0776 10.501 10.2734 11.8639L13.4051 13.6593C13.935 13.96 14.5783 13.96 15.0987 13.6593L18.2209 11.8639C17.4451 10.4916 15.9597 9.57983 14.2566 9.57983Z",
    fill: "#DDBEDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4107 13.6498L10.279 11.8545C9.88167 12.5313 9.66406 13.302 9.66406 14.1386C9.66406 16.6577 11.7172 18.6974 14.2528 18.6974C16.7884 18.6974 18.8415 16.6577 18.8415 14.1386C18.8415 13.3114 18.6144 12.5219 18.2265 11.8545L15.1043 13.6498C14.5839 13.9506 13.9311 13.9506 13.4107 13.6498Z",
    fill: "#FAFBFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9707 19.711L18.2371 16.4211C17.4424 17.7841 15.9569 18.7052 14.2539 18.7052V25.9429C14.5283 25.9429 14.7932 25.8677 15.0392 25.7361L23.9707 20.6134C23.9707 20.6134 23.9801 20.6134 23.9801 20.604C24.3207 20.3972 24.3113 19.899 23.9707 19.711Z",
    fill: "#783393"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2532 18.6962C12.5501 18.6962 11.0647 17.7844 10.27 16.4121L3.96875 20.0403C4.10121 20.2753 4.2999 20.4727 4.53643 20.6043L13.4679 25.7271C13.7139 25.8681 13.9788 25.9339 14.2532 25.9339V18.6962Z",
    fill: "#4B2D87"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2532 9.5802V2.34253C13.9788 2.34253 13.7139 2.41773 13.4679 2.54932L4.53643 7.67209C4.29043 7.81308 4.10121 8.01047 3.96875 8.23606L10.2794 11.8549C11.0742 10.492 12.5596 9.5802 14.2532 9.5802Z",
    fill: "#783393"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9801 7.67148C23.9801 7.67148 23.9707 7.67148 23.9801 7.67148L15.0392 2.53931C14.7932 2.39832 14.5283 2.33252 14.2539 2.33252V9.57019C15.9569 9.57019 17.4424 10.4819 18.2371 11.8543L23.9707 8.56444C24.3113 8.37645 24.3207 7.87827 23.9801 7.67148Z",
    fill: "#4B2D87"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66556 14.1385C9.66556 13.3114 9.89263 12.5218 10.2805 11.8544L3.96987 8.2356C3.83741 8.47059 3.76172 8.73377 3.76172 9.01576V19.2613C3.76172 19.5339 3.83741 19.8065 3.96987 20.0415L10.2805 16.4226C9.89263 15.7553 9.66556 14.9657 9.66556 14.1385Z",
    fill: "#AC6DAD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2365 16.4211C17.4417 17.7841 15.9563 18.7052 14.2627 18.7052C13.5815 18.7052 12.9382 18.5548 12.3516 18.2917L20.1855 22.7847L23.9795 20.6134C24.3296 20.416 24.3296 19.9084 23.9795 19.711L18.2365 16.4211Z",
    fill: "url(#paint0_linear_2479_246606)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2479_246606",
    x1: 21.9062,
    y1: 22.6937,
    x2: 19.5136,
    y2: 14.4159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D3079",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D3079",
    stopOpacity: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAr2);
export default __webpack_public_path__ + "static/media/ar2.ec07c84af15c2a11f4b624fe58e5af06.svg";
export { ForwardRef as ReactComponent };